<template>
    <div v-if="status == 'success'">
        <ticket-filter :action="filterAction"></ticket-filter>
        <div>
            <kt-datatable v-if="$can('read', 'ticket')" v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
    </div>
</template>

<script>
    import { ApiUrl } from '@/common/api.service'
    import columns from '../datatable/columns'
    import commonAccessColumns from '../datatable/commonAccessColumns'
    import actions from '../datatable/actions'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import ticketFilter from './ticket-filter'
    import {mapGetters} from "vuex";

    export default {
        components: {
            ticketFilter,
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {}
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('ticket/fetchCategories')
            })
        },
        computed: {
            datatableProps() {
                return {
                    id: "user_ticket_datatable_for_admin",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('ticket'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions
                }
            },
            commonAccessDatatableProps() {
                return {
                    id: "user_ticket_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('ticket'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: commonAccessColumns,
                    actions: actions
                }
            },
            ...mapGetters('ticket', [
                'status'
            ]),
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        }
    }
</script>